import { shortMonth } from './dateFormatter';

export const requiresPrevious = (periods, currentPeriod) =>
  periods.length > 1 && currentPeriod.periodOrder !== 1;

export const requiresRemainder = (periods, currentPeriod) =>
  periods.length > 1 && currentPeriod.periodOrder !== periods.length;

export const periodTitle = period => {
  if (!period) {
    return 'For your study period';
  }

  const { startDate, endDate } = period;

  if (!startDate || !endDate) {
    return 'For your study period';
  }

  const periodStart = shortMonth(new Date(startDate));
  const periodEnd = shortMonth(new Date(endDate));

  return `For your study period: ${periodStart} - ${periodEnd}`;
};

export const periodShortTitle = period => {
  const { startDate, endDate } = period;

  const periodStart = shortMonth(new Date(startDate));
  const periodEnd = shortMonth(new Date(endDate));

  return `${periodStart} - ${periodEnd}`;
};
